import React, { Component } from 'react';

import Uuid from '../../../../../support/Uuid';
import NominaPercepcionHorasExtraForm from './NominaPercepcionHorasExtraForm';
import NominaPercepcionHorasExtraList from './NominaPercepcionHorasExtraList';

class NominaPercepcionHorasExtraManager extends Component {

  state = {}

  handleOnAdd = (data) => {
    const { HorasExtra = [] } = this.props.data;

    const newList = HorasExtra.concat([{
      id: Uuid.v4(),
      ...data
    }]);

    this.handleOnListChange(newList);
  }

  handleOnEdit = (item) => {
    this.setState({
      data: { ...item }
    }, () => {
      this.setState({
        data: undefined
      });
    });
  }

  handleOnListChange = (data) => {
    this.props.onChange(data);
  }

  render() {
    const { data } = this.state;
    const { HorasExtra=  [] } = this.props.data;

    return (
      <>
        <fieldset>
          <legend>Horas extra</legend>

          <NominaPercepcionHorasExtraForm
            data={ data }
            onAdd={ this.handleOnAdd }
          />

          <NominaPercepcionHorasExtraList
            data={ HorasExtra }
            onEdit={ this.handleOnEdit }
            onChange={ this.handleOnListChange }
          />
        </fieldset>
      </>
    )
  }
}

export default NominaPercepcionHorasExtraManager;